import { useEffect, useMemo, useState } from "react";

import useBomList from "../../../../../hooks/useBomList";
import useCertificateOfOriginStore from "../../../../../stores/certificateOfOriginStore";

export default function useQualifiedBills() {
  const selectedBomIds = useCertificateOfOriginStore((s) => s.selectedBomIds);
  const [selectedBoms, setSelectedBoms] = useState([]);
  const [loading, setLoading] = useState(true);
  const { completedOnly: allBoms, isLoading } = useBomList();

  useEffect(() => {
    if (allBoms && allBoms && Array.isArray(allBoms) && allBoms.length > 0) {
      setSelectedBoms(allBoms.filter((bom) => selectedBomIds.indexOf(bom.BOMID) !== -1));
    } else {
      setSelectedBoms([]);
    }

    return () => setSelectedBoms([]);
  }, [allBoms, selectedBomIds]);

  useEffect(() => {
    if (isLoading && !selectedBoms) {
      setLoading(true);
    } else {
      setLoading(false);
    }

    return () => setLoading(false);
  }, [isLoading, selectedBoms]);

  return useMemo(() => ({ selectedBoms, loading }), [selectedBoms, loading]);
}
